// @flow
import type { ComponentType } from 'react';
import React from 'react';

import type { SelectCellPropTypes } from '../Cells/Select';
import Cell from '../Cells/Select';

type OPTION_TYPE = {
  value: any
};

type SelectPropTypes = {
  accessor: string | Function,
  Header?: string | ComponentType<*> | React$Node,
  editable?: boolean,
  options?: Array<OPTION_TYPE>,
  onChange?: (Object, Object) => mixed,
};

const Select = ({
  accessor,
  Header,
  editable = false,
  onChange,
  options,
  ...props
}: SelectPropTypes) => ({
  Header,
  accessor,
  Cell: ({ value, ...cProps }: { value: SelectCellPropTypes }) => (
    <Cell
      {...value}
      editable={editable}
      options={options}
      onChange={onChange}
      {...cProps}
    />
  ),
  ...props,
});

export default Select;



// WEBPACK FOOTER //
// ./src/scripts/components/DataTable/Columns/Select.jsx